module.exports = __webpack_public_path__ + "img/nodata@3x.a7f14f4b.png";